import { Fragment } from 'react'
import { NextSeo } from 'next-seo'

import NavigationBar from '@/components/NavigationBar'
import Footer from '@/components/Footer'
import { AlternateLink } from '@/components/AlternateLink'

import Blogs from '@/features/landing/templates/Blogs'
import Contact from '@/features/landing/templates/Contact'

import PageHeader from '@/features/otherServices/templates/PageHeader'
import ProductList from '@/features/otherServices/templates/ProductList'
import ContactForm from '@/features/otherServices/templates/ContactForm'

import { useMeta } from '@/features/otherServices/constants'

import { BlogListItem } from '@/features/blogs/types/blog'

import { logEvent } from '@/lib/gtm'

export interface OtherServicesPageProps {
  blogs: BlogListItem[] | null
}

function OtherServicesPage({
  blogs,
}: OtherServicesPageProps): React.ReactElement {
  const META = useMeta()

  return (
    <Fragment>
      <AlternateLink />
      <NextSeo
        title={META.title}
        description={META.description}
        openGraph={{
          title: META.og.title,
          description: META.og.description,
          images: [
            {
              url: META.og.image.url,
              width: 1200,
              height: 630,
              alt: META.og.title,
            },
          ],
        }}
      />
      <NavigationBar />
      <PageHeader />
      <ProductList />
      <ContactForm
        onSuccess={() => {
          logEvent({
            ga: {
              category: 'Submit Form',
              action: 'Success',
              label: 'Other Services',
            },
            fb: {
              event: 'Lead',
            },
          })
        }}
      />
      {blogs && <Blogs blogs={blogs} />}
      <Contact />
      <Footer />
    </Fragment>
  )
}

export default OtherServicesPage
